<template>
    <div class='containers'>
        <!-- <el-carousel :interval="5000" arrow="always">
            <el-carousel-item v-for="item in img" :key="item">
                <img :src="item" alt="">
            </el-carousel-item>
        </el-carousel> -->
        <div class="swiper">
            <swiper :slides-per-view="1" :loop="true" :observer="true" :observeParents="true" :autoHeight="true"
                :navigation="true" :autoplay="{ delay: 3000, stopOnLastSlide: false, disableOnInteraction: false }">
                <swiper-slide v-for="(item, index) in newes" :key="index">
                    <img @click="go_discount(item)" :src="isMobile ? item.images_mobile : item.images" :alt="item.cate_name" style="cursor: pointer;">
                </swiper-slide>
            </swiper>

            <!-- <el-image :src="src"></el-image> -->
        </div>
        <div class="discount">
            <!-- {{ item }} -->
            <div class="discount_item">

                <img v-for="item in discount" v-lazy="item.images" :alt="item.cate_name" @click="go_discount(item)">
            </div>
        </div>
        <!-- <div>
             :thumbs="{ swiper: thumbs }"
            <swiper @swiper="setThumbsSwiper">
                <swiper-slide v-for="(item, index) in img" :key="index" watch-slides-visibility watch-slides-progress>
                    <img :src="item" alt="">
                </swiper-slide>
            </swiper>
        </div> -->
        <Shoptiem v-for="(item, index) in cate" :items="item" :cart_list="cart_list[index]"></Shoptiem>
        <div class="ytb">
            <div v-for="item, index in getyoutube" v-html="getyoutube[index]">
            </div>

        </div>
        <!-- <Footer></Footer> -->
        <Navbar></Navbar>
    </div>
</template>
<script>
import loading_img from '@/components/image_loading.vue'
import Navbar from '@/components/navbar/index.vue'
import Footer from '@/components/footer/index.vue'
import Vue from 'vue';
import { Carousel, CarouselItem, Dialog, Loading } from 'element-ui';
Vue.use(Carousel);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(CarouselItem);
// import Swal from 'sweetalert2/dist/sweetalert2.js'
import { Navigation, Pagination, Autoplay  } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import 'swiper/swiper-bundle.css'
SwiperCore.use([Navigation, Pagination,Autoplay ])
import Shoptiem from '@/components/shopitem/index.vue'
import { mapState } from 'vuex';
import GA4EventApi from '@/js/GA4EventApi';
export default {
    name: 'Main',
    components: {
        Shoptiem,
        Swiper,
        SwiperSlide,
        Navbar,
        Footer,
        loading_img
    },
    data() {
        return {
            img: [
                'https://cdn.cybassets.com/media/W1siZiIsIjEyNTkxL2F0dGFjaGVkX3Bob3Rvcy8xNjk1Nzg2NTIwXzAxLVdFRC0xOTAweDc2MC5qcGcuanBlZyJdXQ.jpeg?sha=173023ea50b134ee',
                'https://imagedelivery.net/i8Xoxd20xJp7bcbNAjF34A/1a931ead-98b3-49c0-7724-d5da73b6db00/swipermobile',
                'https://img95.699pic.com/photo/50075/6447.jpg_wh300.jpg',
                'https://img95.699pic.com/photo/50048/7848.jpg_wh300.jpg',
            ],
            products: [], // 商品列表
            productDetails: null, // 当前选中的商品详情
            centerDialogVisible: false, // 弹窗是否可见
            loading: false, // 是否正在加载商品详情
            list: [
                {
                    id: '1',
                    name: '苹果',
                    price: '200',
                    originalPrice: '300',
                    content: '这个苹果很好吃'
                },
                {
                    id: '2',
                    name: '香蕉',
                    price: '220',
                    originalPrice: '320',
                    content: '这个香蕉很好吃'
                },
                {
                    id: '3',
                    name: '橘子',
                    price: '240',
                    originalPrice: '340',
                    content: '这个橘子很好吃'
                },
                {
                    id: '4',
                    name: '梨子',
                    price: '260',
                    originalPrice: '360',
                    content: '这个梨子很好吃'
                },

            ],
            item: {},
            isMobile: false,
            cart_list: [],
            // webmeta: {
            //     meta_description: '',
            //     meta_keywords: '',
            //     og_description: '',
            //     og_image: '',
            //     og_title: '',
            //     og_url: ''
            // }
        };
    },
    // metaInfo() {
    //     // console.log(123);
    //     // console.log(this);
    //     return {
    //         title: this.webmeta.og_title,
    //         meta: [
    //             { vmid: 'description', name: 'description', content: this.webmeta.meta_description },
    //             { vmid: 'keywords', name: 'keywords', content: this.webmeta.meta_keywords },
    //             { vmid: 'url', property: 'og:url', content: this.webmeta.og_url },
    //             { vmid: 'title', property: 'og:title', content: this.webmeta.og_title },
    //             { vmid: 'og_description', property: 'og:description', content: this.webmeta.og_description },
    //             { vmid: 'image', property: 'og:image', content: this.webmeta.og_image },
    //         ]
    //     }
    // },
    computed: {
        ...mapState('header', ['website', 'newes', 'discount', 'ads', 'mc', 'getfb', 'cate', 'getyoutube']),
    },
    watch: {},
    methods: {
        addToCart(item) {
            this.centerDialogVisible = true;
            // this.loading = true;
            this.item = item
        },
        dialog_close() {
            // console.log(1);
        },
        close() {

        },
        go_discount(item) {
            var  GAFourEventApi = new GA4EventApi();
            GAFourEventApi.select_promotion('促銷',{
                name: item.cate_name,
                id: `${item.cid}`
            });
            this.$router.push({ path: `/categroy/${item.cate_name}/${item.cid}` })
        }
    },
    created() {
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) { // 确保 fbclid 存在且不为空
      document.cookie = "fbclid=" + fbclid + ";path=/;max-age=172800"; // Cookie 保存2天
    }

        if (window.innerWidth > 600) {
            this.isMobile = false;
        } else {
            this.isMobile = true;
        }

        // this.$store.dispatch('header/getwebsite').then(e=>{})
        // this.$store.dispatch('header/get').then(e=>{})
        this.$store.dispatch("header/get").then(async e => {
            var  GAFourEventApi = new GA4EventApi();
            let disc_item=[]
            this.discount.forEach(element => {
                disc_item.push({
                    name: element.cate_name,
                    id: `${element.cid}`
                })
            });
            // console.log(disc_item);
            GAFourEventApi.view_promotion('促銷',disc_item);

            for (const element of this.cate) {
                try {
                    // console.log(element);
                    const response = await this.$store.dispatch('commodity/getclassification', element.cid);
                    if (response.result) {
                        this.cart_list.push(response.data);
                    } else {
                        this.cart_list.push([]); // 或者其他默认值
                    }
                } catch (error) {
                    this.cart_list.push([]); // 或者其他默认值
                }
                // console.log(this.cart_list);
            }
        });

    },
}
</script>
<style lang='scss' scoped>


.containers {
    // display: flex;
    // flex-direction: column;
    // min-height: 50vh;
    // margin: auto;

    img {
        width: 100%;
        height: auto;
        display: block;
        // aspect-ratio: 2 / 1
    }

}

.discount {
    .discount_item {
        margin-top: 30px;
        width: calc(33.3% - 6.66px);

        display: flex;

        img {
            cursor: pointer;

            &:not(:last-child) {
                margin-right: 10px;
            }
        }
    }

    margin: 0 180px 24px;
}

.swiper {

    ::v-deep .swiper-button-prev,
    ::v-deep .swiper-button-next {
        background-color: aliceblue;
        border-radius: 50%;
        height: 32px;
        width: 32px;

        &::after {
            font-size: 12px;
            font-weight: bold;
            color: #a3a3a3;
            // height: 12px;
            // width: 12px;
        }

        &:hover {
            &::after {
                color: #565656;
            }
        }
    }
}

.ytb {
    display: flex;
    flex-wrap: wrap;
    div {
        width: calc(50% - 5px);
    }

    ::v-deep {
        iframe {
            width: 100%;
        }
    }

    div:nth-child(2n) {
        margin-left: 10px;
    }

    margin: 0 80px 48px;
}

@media(max-width:1200px) {
    .containers {}

    .ytb {
        margin: 0 80px 48px;

    }

    .discount {
        margin: 0 65px 24px;
    }
}

@media(max-width:991px) {
    .containers {}

    .discount {
        .discount_item {
            width: 100%;
            flex-direction: column;

            img {
                margin-bottom: 10px;
                margin-right: 0;
            }
        }

        margin: 0 0px 24px;
    }

    .ytb {
        flex-direction: column;
        margin: 0 30px 24px;

        div {
            width: 100%;
        }

        div:nth-child(2n) {
            margin-left: 0px;
        }
    }

}

// @media (max-width: 1200px) {
//     .container {
//         max-width: 1140px;
//     }
// }

@media (min-width:992px) {}

@media (max-width: 576px) {}

@media (min-width: 581px) and (max-width: 991px) {}

@media (max-width: 768px) {}

@media (max-width: 576px) {}
</style>
